"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateNewCatalog = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const client_utils_1 = require("../../client.utils");
const product_tree_1 = require("../../product-tree");
const get_global_product_tree_query_1 = require("../../product-tree/get-global-product-tree.query");
const create_tags_hook_1 = require("../../tags/create-tags.hook");
const ticket_1 = require("../../ticket");
const create_catalog_supply_hook_1 = require("../create-catalog-supply.hook");
const create_catalog_hook_1 = require("../create-catalog.hook");
const get_catalogs_query_1 = require("../get-catalogs.query");
const upload_catalog_hook_1 = require("../upload-catalog.hook");
const global_tree_edit_warning_utils_1 = require("../../../components/global-tree-edit-warning/global-tree-edit-warning.utils");
const store_1 = require("../../../../store");
const useCreateNewCatalog = () => {
    const selectedProjectId = (0, store_1.useSelectedProjectId)();
    const isSelectedProjectStrategy = (0, store_1.useIsSelectedProjectStrategy)();
    const catalogDefaultTags = (0, store_1.useSelectedProjectTags)();
    const { createCatalog } = (0, create_catalog_hook_1.useCreateCatalog)(selectedProjectId);
    const { uploadCatalog } = (0, upload_catalog_hook_1.useUploadCatalog)();
    const { createCatalogSupply } = (0, create_catalog_supply_hook_1.useCreateCatalogSupply)();
    const { attachGlobalProductTreeToCatalog } = (0, product_tree_1.useAttachGlobalProductTreeToCatalog)();
    const { cloneAndAttachProductTreeToCatalog } = (0, product_tree_1.useCloneAndAttachProductTree)();
    const [getGlobalProductTree] = (0, react_2.useLazyQuery)(get_global_product_tree_query_1.GET_GLOBAL_PRODUCT_TREE, { fetchPolicy: 'network-only' });
    const { createTicketSequenceForCatalog } = (0, ticket_1.useCreateTicketSequenceForCatalog)();
    const { createTags } = (0, create_tags_hook_1.useCreateTags)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const createNewCatalog = (0, react_1.useCallback)((fileToUpload) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        if (!selectedProjectId) {
            return;
        }
        setError(null);
        setIsLoading(true);
        // TODO: allow the user to provide a title and description to the catalog
        const { id: title, file } = fileToUpload;
        try {
            const createCatalogResponse = yield createCatalog({ variables: { title, description: 'test description' } });
            (0, client_utils_1.genericGraphQLErrorsHandler)(createCatalogResponse);
            const { id: catalogId, title: catalogName } = createCatalogResponse.data.catalog;
            const createTagsResponse = yield createTags({ variables: { reference: catalogId, tags: catalogDefaultTags } });
            (0, client_utils_1.genericGraphQLErrorsHandler)(createTagsResponse);
            const { data: uploadCatalogResponseData } = yield uploadCatalog({ variables: { name: catalogName, file } });
            const { id: uploadId } = uploadCatalogResponseData.upload;
            const createCatalogSupplyResponse = yield createCatalogSupply({ variables: { catalogId, uploadId } });
            (0, client_utils_1.genericGraphQLErrorsHandler)(createCatalogSupplyResponse);
            if (isSelectedProjectStrategy) {
                yield attachGlobalProductTreeToCatalog({ variables: { catalogId } });
            }
            else {
                const getGlobalProductTreeResponse = yield getGlobalProductTree();
                (0, client_utils_1.genericGraphQLErrorsHandler)(getGlobalProductTreeResponse);
                const { id: productTreeId } = (_e = (_d = (_c = (_b = (_a = getGlobalProductTreeResponse.data) === null || _a === void 0 ? void 0 : _a.productTrees) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.node) !== null && _e !== void 0 ? _e : {};
                if (!productTreeId) {
                    throw new Error('No product trees were found');
                }
                yield cloneAndAttachProductTreeToCatalog({
                    variables: {
                        productTreeId,
                        title: (0, global_tree_edit_warning_utils_1.getCopyProductTreeTitle)(catalogName),
                        catalogId,
                    },
                });
            }
            const createTicketSequenceForCatalogResponse = yield createTicketSequenceForCatalog({
                catalogId,
                tags: catalogDefaultTags,
                tickets: ticket_1.TICKETS_FOR_THE_NEW_CATALOG,
                variables: { projectId: selectedProjectId },
                awaitRefetchQueries: true,
                refetchQueries: [get_catalogs_query_1.GET_CATALOGS],
            });
            (0, client_utils_1.genericGraphQLErrorsHandler)(createTicketSequenceForCatalogResponse);
            return catalogId;
        }
        catch (e) {
            setError(e);
            throw new Error(e.message);
        }
        finally {
            setIsLoading(false);
        }
    }), [
        catalogDefaultTags,
        selectedProjectId,
        isSelectedProjectStrategy,
        attachGlobalProductTreeToCatalog,
        cloneAndAttachProductTreeToCatalog,
        createCatalog,
        createCatalogSupply,
        createTags,
        createTicketSequenceForCatalog,
        getGlobalProductTree,
        uploadCatalog,
    ]);
    return {
        createNewCatalog,
        loading: isLoading,
        error,
    };
};
exports.useCreateNewCatalog = useCreateNewCatalog;
